import { cn } from '../../lib/cn';
import { ROLE_LABELS } from '../../services/auth/permissions';
import type { CollaboratorRole } from '../../services/auth/permissions';

interface CollaboratorRoleBadgeProps {
  role: string;
  className?: string;
}

const ROLE_STYLE: Record<CollaboratorRole, string> = {
  admin:
    'bg-cime-gold/15 text-cime-gold border border-cime-gold/30',
  lawyer:
    'bg-cime-primary/10 text-cime-primary border border-cime-primary/20',
  secretary: 'bg-neutral-100 text-neutral-700 border border-neutral-200',
  client_portal: 'bg-blue-50 text-blue-700 border border-blue-200',
};

const DEFAULT_STYLE = 'bg-neutral-100 text-neutral-600 border border-neutral-200';

export function CollaboratorRoleBadge({ role, className }: CollaboratorRoleBadgeProps) {
  const typedRole = role as CollaboratorRole;
  const label = ROLE_LABELS[typedRole] ?? role;
  const style = ROLE_STYLE[typedRole] ?? DEFAULT_STYLE;

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        style,
        className,
      )}
    >
      {label}
    </span>
  );
}
